import React ,{useState} from 'react'
import { useNavigate} from 'react-router-dom'
import {Form ,Button,Col} from 'react-bootstrap'
import {useDispatch,useSelector} from 'react-redux'
import FormContainer from '../components/FormContainer'
import CheckoutSteps from '../components/CheckoutSteps'
import { savePaymentMethod } from '../actions/cartActions'

const PaymentScreen = () => {

    const cart=useSelector((state)=> state.cart)
    const {shippingAddress}=cart
    const navigate=useNavigate();
    const dispatch=useDispatch()
    const [paymentMethod,setPaymentMethod]=useState('PayPal')

    
    if(!shippingAddress){
        navigate('/login/shipping')
    }

    const submitHandler=(e)=>{
        e.preventDefault()
       dispatch(savePaymentMethod(paymentMethod))//this is action
        
         navigate('/placeorder')

   
    }

  return (
    <FormContainer>
        <CheckoutSteps step1 step2 step3/>
        <h1 > Payment Method</h1>
        <Form onSubmit={submitHandler}>
            <Form.Group>
                <Form.Label as='legend' > Select Method </Form.Label>
            
            <Col>
                <Form.Check
                 type='radio' 
                 label='Paypal or Credit Card'
                 id='PayPal'
                 name='paymentMethod'
                 value='PayPal'
                 checked
                 onChange={(e)=> setPaymentMethod(e.target.value)}>
                </Form.Check>

                <Form.Check
                 type='radio' 
                 label='Stripe'
                 id='Stripe'
                 name='paymentMethod'
                 value='Stripe'
                 onChange={(e)=> setPaymentMethod(e.target.value)}>
                </Form.Check>
            </Col>
            </Form.Group>
       

            <Button type='submit' variant='primary' className='mt-3'> Continue</Button>
        </Form>
    </FormContainer>
  )
}

export default PaymentScreen